
//Variable that enables display of relayPoint after switching delivery modes
var showRelaypoint = false;

document.addEventListener("DOMContentLoaded", function(event) {

    var isDevice = {
        large: $(window).width() > 1023,
        medium: $(window).width() > 719 && $(window).width() < 1024,
        xmedium: $(window).width() > 479 && $(window).width() < 720,
        small: $(window).width() > 319 && $(window).width() < 480
    };
    const DOM = {
        swiper: '.js-product-cross-selling-container:not("[data-slider]")',
        slide: '.js-slider-slide',
        pagination: '.js-product-cross-selling-pagination',
        next: '.js-slider__button-next',
        prev: '.js-slider__button-prev',
    };
    const
        $swiper = $(DOM.swiper),
        $slide = $(DOM.swiper).find(DOM.slide),
        $pagination = $(DOM.pagination)
    ;
    var slides = [];

    const Breakpoints = {
        extra: {
            max: '1600'
        },
        large: {
            min: '1025',
            max: '1599'
        },
        medium: {
            min: '768',
            max: '1024'
        },
        xmedium: {
            min: '480',
            max: '767'
        },
        small: {
            min: '320',
            max: '767'
        }
    };

    var initCrossSelling = function(){
        if($('#crossSelling').length){

            var crossSellingItems;
            if(isDevice.large || isDevice.medium)
                crossSellingItems = 3;
            else if(isDevice.xmedium)
                crossSellingItems = 2;
            else if(isDevice.small)
                crossSellingItems = 1;

            var crossSellingCarrousselOptions = {
                items : crossSellingItems,
                slideBy : crossSellingItems,
                margin:35,
                nav: false,
                navText: ['prev', 'next'],
                onInitialized: function(event) {
                    var items = event.item.count;
                    if (items <= crossSellingItems) {
                        $('.owl-carousel .owl-dots').addClass("hidden");
                    }
                },
                dots: true
            };

            var crossSellingCarrousselOptionsForKrups = {
                items : crossSellingItems,
                slideBy : crossSellingItems,
                margin:35,
                dots: true,
                nav: false,
                navText: ['prev', 'next']
            };

            var fixDotsLastPage = function(event) {
                if (event.item) {
                    if(event.item.index % crossSellingCarrousselOptionsForKrups.items != 0) {
                        $("#crossSelling .owl-dot").removeClass("active")
                        $("#crossSelling .owl-dot:last-child").addClass("active")
                    }
                }
            };

            if(GSEB.constants.site=="Moulinex") {
                crossSellingCarrousselOptions.margin = 5;
                crossSellingCarrousselOptions.dots = false;
                crossSellingCarrousselOptions.nav = true;
            }
            if(GSEB.constants.site=="Rowenta") {
                crossSellingCarrousselOptions.margin = 10;
                crossSellingCarrousselOptions.dots = false;
                crossSellingCarrousselOptions.nav = true;
            }
            if(GSEB.constants.site=="SEB") {
                crossSellingCarrousselOptions.margin = 10;
            }
            if(GSEB.constants.site=='Tefal'){
                crossSellingCarrousselOptions.margin=8;
                crossSellingCarrousselOptionsForKrups.margin = 8;
                crossSellingCarrousselOptionsForKrups.dots = false;
                crossSellingCarrousselOptionsForKrups.nav = true;
                crossSellingCarrousselOptionsForKrups.navText =['&#8249;', '&#8250;'];
            }
            if(GSEB.constants.site=='Calor'){
                crossSellingCarrousselOptions.margin=10;
                crossSellingCarrousselOptions.dots = false;
                crossSellingCarrousselOptions.nav = true;
            }
            if(GSEB.constants.site=='AllClad'){
                crossSellingCarrousselOptions.margin=32;
            }
            if(GSEB.constants.site=='VPC'){
                crossSellingCarrousselOptionsForKrups.margin = 10;
            }
            try {
                if(GSEB.constants.site=="Krups" || GSEB.constants.site=="VPC" || GSEB.constants.site=='Tefal'){
                    var owl = $('#crossSelling .owl-carousel').owlCarousel(crossSellingCarrousselOptionsForKrups);
                    owl.on('refresh.owl.carousel refreshed.owl.carousel', function(event) {
                        var items = event.item.count;
                        if (items <= crossSellingCarrousselOptionsForKrups.items) {
                            $('.owl-carousel .owl-dots').addClass("hidden");
                        }
                    });
                    owl.on('changed.owl.carousel', fixDotsLastPage);
                }
                else
                    $('#crossSelling .owl-carousel').owlCarousel(crossSellingCarrousselOptions);
            }catch (error) {
                return 0;
            }

            setTimeout(function () {
                $('#crossSelling').show();
                window.dispatchEvent(new Event('resize'));
            }, 400);
            return 1;
        }
    };

    var initCrossSellingSwiper = function() {
        if($('#crossSelling').length) {

            // Bind UI events ,  Orientation change
            window.addEventListener("orientationchange", function (_) {
                $(window).resize(rebuildSwiper);
            }, false);

            // Initialize swiper
            initialSwiper();

            // Next & Previous height adaptive
            adaptingHeight();

            setTimeout(function () {
                $('#crossSelling').show();
                window.dispatchEvent(new Event('resize'));
            }, 400);
            return 1;
        }
    };

    /**
     * Destroy Swiper carousels
     * Private function
     *
     * @function rebuildSwiper
     */
    function rebuildSwiper() {
        // Loop on slides
        slides.forEach(function (slider, index) {
            // Destroy the main slider
            if (typeof slider !== 'undefined') {
                slider.destroy();
                slider = undefined;
                $('.swiper-' + index + '-pagination').html('');
            }
        });

        // Re-init slides before swiper init
        slides = [];

        // Initialize slider again
        initialSwiper();

        slides.forEach(function (slider) {
            // Update the DOM after initializing
            if (typeof slider !== 'undefined') {
                slider.update();
            }
        });
    };
    /**
     * initialize Swiper
     * Private function
     **
     * @function initialSwiper
     */
    function initialSwiper() {

        var windowWidth = window.innerWidth;

        // Treatement
        $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment).find(".js-product-cross-selling-container").each(function (index, element) {
            var
                $this = $(element),
                slider
            ;

            // Add specific class's
            $this.addClass('swiper-' + index + '-container');
            $this.parent().find(DOM.pagination).addClass('swiper-' + index + '-pagination');
            $this.parent().find(DOM.next).addClass('swiper-' + index + '-next');
            $this.parent().find(DOM.prev).addClass('swiper-' + index + '-prev');

            /**
             * In the case of tablet resolution and desktop we display thumbs
             * In the case of mobile we display only a fraction
             */

            if (windowWidth >= Breakpoints.large.min && $slide.length > 3) {
                slider = new Swiper('.swiper-' + index + '-container', {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-' + index + '-pagination',
                        clickable: true
                    },
                    navigation: {
                        nextEl: '.swiper-' + index + '-next',
                        prevEl: '.swiper-' + index + '-prev'
                    }
                });
            } else if ((windowWidth >= Breakpoints.medium.min && windowWidth < Breakpoints.large.min
                || windowWidth >= Breakpoints.medium.min && windowWidth < Breakpoints.large.min) && $slide.length > 2) {
                slider = new Swiper('.swiper-' + index + '-container', {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-' + index + '-pagination',
                        clickable: true
                    }
                });
            } else if (windowWidth < Breakpoints.xmedium.min && $slide.length > 1) {
                slider = new Swiper('.swiper-' + index + '-container', {
                    observer: true,
                    observeParents: true,
                    pagination: {
                        el: '.swiper-' + index + '-pagination',
                        clickable: true
                    }
                });
            }

            slides.push(slider);
        });
    };
    /**
     * Adaptation for next and previous buttons
     * Private function
     *
     * @function adaptingHeight
     */
    function adaptingHeight() {
        if ($swiper.hasClass('js-swiper-adaptive')) {
            const height = $swiper.find('.o-plot-product').height();
            $swiper.find(DOM.prev).height(height);
            $swiper.find(DOM.next).height(height);
        }
    };
    if(initCrossSelling()==0) {
        setTimeout(function () {
            initCrossSelling();
        }, 500);
    }

    var HTTP_METHODS =  {
        get : "GET",
        post : "POST"
    };
    var headerSize = {
        Rowenta: 80,
        Moulinex: 100,
        VPC : 80 ,
        Krups: 75,
        SEB: 100,
        Tefal:74,
        Calor:80,
        AllClad:140
    };
    var originalHeight = $(window).height();
    var PURCHASE_TUNNEL = {
        selectors: {
            cartPage: {
                cartFragment : "#fragmentCartPage",
                updateQuantity : ".updateQuantityEntry",
                removeEntry : ".removeEntry",
                removeEntryConf : ".ConfDelbtn",
                inputVoucherCode: "#voucherCode",
                addVoucher : "#addVoucher",
                releaseVoucher : "#releaseVoucher",
                addProduct: ".addProduct"
            },
            deliveryPage: {
                selectDeliveryMode: "input[name=deliveryMode]",
                trSelectDeliveryMode: ".delivery-mode-table tbody > tr",
                deliveryFragment: "#fragmentDeliveryPage",
                editAddress: ".edit-address-button",
                addOrEditAddress: ".addNewAddress,.editAddress",
                cancelAddAddress: ".cancelAddAddress",
                updateAddress: ".updateAddress",
                removeAddress: ".removeAddress",
                setDefaultAddress: ".setDefaultAddress",
                connected: ".connected"
            },
            paymentPage: {
                selectPaymentMode: "input[name=payment-mode]",
                paymentFragment: "#fragmentPaymentPage",
                validateTaxNumber: "#tax-number",
                validatePhoneNumber: "#mobilePhoneValidate",
                validateEmailGuestCheckout: "#emailGcValidate",
                trSelectPaymentMode: ".payment-mode-table tbody > tr"
            },
            confirmationPage: {
                registerProductsModal: ".registerProductsModal",
                accepteRegisterProductsBtn: "#accepteRegisterProductsBtn",
                rejectRegisterProductsBtn: "#rejectRegisterProductsBtn",
            }
        } ,
        ajaxUrl: {
            cartFragment : "/cart/ajax",
            updateQuantity: "/cart/update",
            updateQuantityForBundle: "/cart/updateBundle",
            addVoucher: "/cart/checkVoucher",
            releaseVoucher: "/cart/releaseVoucher",
            addProduct: "/cart/add/ajax",
            loadAddress: "/my-account/address-book/load-address",
            addAddress: "/my-account/address-book/add-address",
            removeAddress: "/my-account/remove-address/ajax/",
            setDefaultAddress: "/checkout/multi/address-book/set-default-address/ajax",
            getTotalCartSection: "/checkout/multi/totalCartSection/ajax",
            registerProducts: "/my-account/rp/order/",
            guestLoadAddress: "/checkout/address-book/load-address",
            guestAddAddress: "/checkout/address-book/add-address",
            guestRemoveAddress: "/checkout/remove-address/ajax/",
        }
    };
    PURCHASE_TUNNEL.selectors.multiple = {
        deliveryAndPaymentPageFragment : PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment+","+PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment,
        deliveryAndPaymentPageFragmentForConnected : PURCHASE_TUNNEL.selectors.deliveryPage.connected+PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment+","+PURCHASE_TUNNEL.selectors.deliveryPage.connected+PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment
    };
    spinnerON = function(selector) {
        if(selector)
            $(selector).block({
                message: '<div align="center" class="spinner"><img src="/_ui/desktop/common/img/img-defer-spinner.svg"/></div>',
                overlayCSS:  {
                    'backgroundColor': '#000',
                    'opacity':         0.2,
                    'cursor':          'wait' ,
                    'z-index': 200,
                },
                css: {
                    'z-index': 205,
                    'border': 0,
                    'background-color': 'transparent'
                }
            });
        else
        if(!$('.blockUI.blockOverlay').length > 0) {
            $.blockUI({
                message: '<div align="center" class="spinner"><img src="/_ui/desktop/common/img/img-defer-spinner.svg"/></div>',
                overlayCSS:  {
                    'backgroundColor': '#000',
                    'opacity':         0.2,
                    'cursor':          'wait' ,
                    'z-index': 200,
                },
                css: {
                    'z-index': 205,
                    'border': 0,
                    'background-color': 'transparent'
                }
            });
        }
    };
    spinnerOFF = function(selector) {
        if(selector)
            $(selector).unblock();
        else
            $(document).ajaxStop($.unblockUI);
    };
    checkUserIfLoggedOut = function(data) {
        if(data.includes('body class="page-login ')) {
            window.location = "/login";
        }
    };

    var updateFragmentCart = function (url, data, httpMethod, scrollTo) {
        spinnerON();
        $.ajax({
            type: httpMethod,
            url: url,
            data: data
        }).done(function(result){

            if(url === PURCHASE_TUNNEL.ajaxUrl.addVoucher){
                var res = {};
                var operationContents = $(result).find(".applied-voucher .voucher-title").first().contents();
                var codeContents = $(result).find(".applied-voucher .voucher-title p").first().contents();
                res.voucherOperation = typeof operationContents.get(0) !== 'undefined' ? operationContents.get(0).nodeValue.trim() : '';
                res.voucherCode = $(result).find('#voucherCode').first().val() || (typeof codeContents.get(0) !== 'undefined' ? codeContents.get(0).nodeValue : '');
                res.voucherAvailability = $(result).find('.add-voucher').length > 0 ? "no" : "yes";
                if (typeof tC !== 'undefined' && typeof tC.event !== 'undefined' &&  typeof tC.event.clickBasketPromoCode !== 'undefined') {
                    tC.event.clickBasketPromoCode(this, res);
                }
                var isNotWwwDomain = window.location.href.indexOf("www.") == -1;
                if(isNotWwwDomain){
                    demoEvent('tC.event.clickBasketPromoCode', res);
                }
            }

            $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment).html(result);

            if ($(".js-product-cross-selling-container").length) {
                initCrossSellingSwiper();
            } else {
                initCrossSelling();
            }
            if(url == PURCHASE_TUNNEL.ajaxUrl.addProduct
                || url == PURCHASE_TUNNEL.ajaxUrl.updateQuantity
                || url == PURCHASE_TUNNEL.ajaxUrl.updateQuantityForBundle) {
                ACC.cartpopup.refreshMiniCart();
            }
            if(scrollTo) {
                scrollToElement(scrollTo)
            }
        }).fail(function(){

        }).always(function(){
            spinnerOFF();
        });
    };

    var escapeSingleQuoteJson = function(json) {
        json  = HTMLunEscape(json);
        return json.replace(/\\'/g, "'");
    };

    function isMobile() {
        return $(window).width() < 720;
    };
    var scrollToElement = function (scrollTo) {
        $('html, body').animate({
            scrollTop: $(scrollTo).offset().top-headerSize[GSEB.constants.site]
        }, 500);
    };
    /******************************
     CartPage
     *******************************/
    //Update Quantity
    $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment)
        .on("change", PURCHASE_TUNNEL.selectors.cartPage.updateQuantity, function(){
            var data ;
            var url;
            if($(this).closest("tr").attr("data-bundle-id")) {
                data = {
                    quantity: $(this).val(),
                    bundleID: $(this).closest("tr").attr("data-bundle-id")
                };
                url = PURCHASE_TUNNEL.ajaxUrl.updateQuantityForBundle;
            }else {
                data = {
                    quantity: $(this).val(),
                    entryNumber: $(this).closest("tr").attr("data-entry-number")
                };
                url = PURCHASE_TUNNEL.ajaxUrl.updateQuantity;
            }

            updateFragmentCart(url, data, HTTP_METHODS.post);
        });

    //Remove Product Modal
    $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment)
        .on("click", PURCHASE_TUNNEL.selectors.cartPage.removeEntry, function(e){
            e.preventDefault();
            $('.ConfDelModal .modal-footer .ConfDelbtn').removeAttr("data-bundle-id");
            $('.ConfDelModal .modal-footer .ConfDelbtn').removeAttr("data-entry-number");
            if($(this).closest("tr").attr("data-bundle-id")) {
                var bundleID = $(this).closest("tr").attr("data-bundle-id");
                $('.ConfDelModal .modal-footer .ConfDelbtn').attr("data-bundle-id", bundleID);
            }else {
                var entryNumber = $(this).closest("tr").attr("data-entry-number");
                $('.ConfDelModal .modal-footer .ConfDelbtn').attr("data-entry-number", entryNumber);
            }

            jQuery('.ConfDelModal').modal();
        });

    $(PURCHASE_TUNNEL.selectors.cartPage.removeEntryConf)
        .on("click", function (e) {
            var data ;
            var url;
            if($('.ConfDelModal .modal-footer .ConfDelbtn').attr("data-bundle-id")) {
                data = {
                    quantity: 0,
                    bundleID: $('.ConfDelModal .modal-footer .ConfDelbtn').attr("data-bundle-id")
                };
                url = PURCHASE_TUNNEL.ajaxUrl.updateQuantityForBundle;
            }else {
                data = {
                    quantity: 0,
                    entryNumber: $('.ConfDelModal .modal-footer .ConfDelbtn').attr("data-entry-number")
                };
                url = PURCHASE_TUNNEL.ajaxUrl.updateQuantity;
            }
            updateFragmentCart(url, data, HTTP_METHODS.post);
            $(".ConfDelModal").find(".close").trigger("click");
        });


    //Add Voucher Code
    $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment)
        .on("click", ".add-voucher > button", function(){
            $(this).siblings("#FormPromotion").show();
            $(this).hide();
            $(this).siblings("label").hide();
        });
    $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment)
        .on("click", PURCHASE_TUNNEL.selectors.cartPage.addVoucher, function(){
            var data = {
                voucherCode: $(PURCHASE_TUNNEL.selectors.cartPage.inputVoucherCode).val()
            };
            updateFragmentCart(PURCHASE_TUNNEL.ajaxUrl.addVoucher, data, HTTP_METHODS.post);
        });

    //Release applied Voucher
    $(PURCHASE_TUNNEL.selectors.cartPage.cartFragment)
        .on("click", PURCHASE_TUNNEL.selectors.cartPage.releaseVoucher, function(){
            var data = {
                voucherCode: $(PURCHASE_TUNNEL.selectors.cartPage.inputVoucherCode).val()
            };
            updateFragmentCart(PURCHASE_TUNNEL.ajaxUrl.releaseVoucher, data, HTTP_METHODS.post);
        });

    /******************************
     ChooseDeliveryPage
     *******************************/

    if ($(".adress-container").length > 0 || $('.addressesBloc').length > 0) {
        function heightEqualizer() {
            if($(".adress-container").length > 0) {
                var max = 0;
                $.each($(".adress-container > .address-card > span"), function (i, element) {
                    max = $(element).actual('height') > max ? $(element).actual('height') : max;
                });
                $(".adress-container > .address-card > span").attr("style", "min-height:" + (isMobile() ? 0 : max) + "px");
                $('.adress-container .address-card').show();
            }
            if ($('.addressesBloc').length > 0) {
                var max = 0;
                $.each( $(".addressesBloc > .span6 >p"), function( i, element ){
                    max = $(element).actual('height') > max ? $(element).actual('height') : max;
                });
                $(".addressesBloc > .span6 >p").attr("style","min-height:" + (isMobile() ? 0 : max) + "px");
            }
        }
        $(window).on('resize', function() {
            setTimeout(function () {
                heightEqualizer();
            },500);
        });
        $(window).on('load', function() {
            setTimeout(function () {
                heightEqualizer();
            },500);
        });
    }

    function getTotalCartSection() {
        var stepName;
        if($("#fragmentPaymentPage").length > 0) {
            stepName = "payment";
        }else {
            stepName ="delivery";
        }
        spinnerON();
        $.ajax({
            type: HTTP_METHODS.get,
            data: { stepName: stepName },
            url: PURCHASE_TUNNEL.ajaxUrl.getTotalCartSection
        }).done(function(result){
            var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
            $("#totalCartSection").html(jsonResponse.totalCartSection);
            if(!jsonResponse.success){
                if(jsonResponse.hasOwnProperty("message")) {
                    addMessage(jsonResponse.success, jsonResponse.message);
                    scrollToElement("#globalMessages");
                }
            }
            if(typeof hasExternalErrorDeliveryMode !== "undefined" && hasExternalErrorDeliveryMode == true) {
                if(!$(".submit-container .ui-btn").hasClass("ui-btn-disabled")) {
                    $(".submit-container .ui-btn").addClass("ui-btn-disabled");
                    $("#priceZone").html($(".deliveryCostTR .values-container").html());
                }
            }else {
                if($(".submit-container .ui-btn").hasClass("ui-btn-disabled")) {
                    $(".submit-container .ui-btn").removeClass("ui-btn-disabled");
                }
            }
        }).fail(function(){

        }).always(function(){
            spinnerOFF();
        });
    }

    //BRA-5310
    function validateTheDeliveryMode(radioInput, callBack1, callBack2) {
        if($(radioInput).is(':checked')){
            var deliveryModeCode = radioInput.attr("value");
            var ajaxUrl = $("#isValidDeliveryAjaxUrl").attr("value");
            var params = {"deliveryModeCode": deliveryModeCode};
            spinnerON();
            $.ajax({
                type: HTTP_METHODS.post,
                url: ajaxUrl,
                data: params
            }).done(function(result){
                checkUserIfLoggedOut(result);
                var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
                $("#hasExternalError").remove();
                if(jsonResponse.valid) {
                    if(jsonResponse.showRelayPoint != null) {
                        showRelayPoint = jsonResponse.showRelayPoint;
                    }
                    if(jsonResponse.isExternalDeliveryMode) {
                        hasExternalErrorDeliveryMode = false;
                        checkedInput = $('input[name=deliveryMode]:checked');
                        if(checkedInput[0].hasAttribute("data-isExternal")) {
                            checkedInput.prop("disabled", false);
                        }
                    }
                    $(".priceZone."+deliveryModeCode).siblings('span:first').html(jsonResponse.deliveryCost);
                    if(callBack1) {
                        if(callBack2) {
                            callBack1(callBack2);
                        }else {
                            callBack1();
                        }
                    }
                }else {
                    //$("#priceZone").addClass("hidden");
                    $("#deliveryErrorMessage").addClass("invalid-delivery");
                    $("#deliveryErrorMessage").removeClass("hidden");
                    if(jsonResponse.isExternalDeliveryMode) {
                        if($("#fragmentPaymentPage").length > 0) {
                            window.location.href= "/checkout/multi/choose-delivery";
                            return;
                        }
                        checkedInput = $('input[name=deliveryMode]:checked');
                        if(checkedInput[0].hasAttribute("data-isExternal")) {
                            checkedInput.prop("disabled", true);
                        }
                        hasExternalErrorDeliveryMode = true;
                        if(!hasNoDeliveryAddress) {
                            $(".delivery-mode-table").append('<span class="skip" id="hasExternalError"> <span id="message.errors">'+jsonResponse.message+'</span> </span>');
                        }
                    }
                }
                getTotalCartSection();
            }).fail(function(){

            }).always(function(){
                spinnerOFF();
            });

        }
    }

    function initDeliveryMode(thisObj) {
        if($(thisObj)[0].hasAttribute("data-isprelais")) {
            initPointsRelaisDeliveryMode(thisObj);
            displayRelayPointInformationForm();
            $(".address--active").removeClass("address--active");
        }else {
            $('#relayPointFormContainer').hide();
            initStandardDeliveryMode(thisObj);
        }
    }

    function initStandardDeliveryMode(thisObj){
        validateTheDeliveryMode($(thisObj), appendDeliveryAddress);
        $('#AddressesSection').removeClass('hidden');
    }

    function initPointsRelaisDeliveryMode(thisObj){
        if($(thisObj)[0].getAttribute("data-deliveryProvider") == 'DPD' || $(thisObj)[0].getAttribute("data-deliveryProvider") == 'UPS' || $(thisObj)[0].getAttribute("data-deliveryProvider") == 'GLS'){
            $('.pRelaisDetails').hide();
            validateTheDeliveryMode($(thisObj), appendRelaisGRPMap, searchPointsRelaisByDefaultGRP);
        } else {
            $('.pRelaisDetailsGRP').hide();
            validateTheDeliveryMode($(thisObj), appendRelaisMap, searchPointsRelaisByDefault);
        }
        if(!$("body").hasClass("emptyAddress")) $('#AddressesSection').addClass('hidden');
    }

    function scrollToPointsRelais(time) {
        $('html, body').animate({
            scrollTop: $("#pointRelaisDetails").offset().top - 50
        }, time);
    }

    function appendRelaisMap(callBack){
        var relaisMap = $(".pRelaisDetails");
        var grpMap = $("#pointRelaisDetails");
        var detailRelais = $("#pointAcheminementDetail");
        var radioInput = $(".delivery-mode .form-horizontal").find("input[name='deliveryMode']:checked");
        if (showRelayPoint != null && showRelayPoint == true && $(".pRelaisDetails #pointAcheminementDetail").length) {
            $(relaisMap).show('slow');
            $(grpMap).hide();
            $(detailRelais).show();
        }
        else {
            var parent = $(radioInput).closest(".radiostyle");
            var relaisMap = $(".pRelaisDetails");
            $(detailRelais).hide();
            $(grpMap).show();
            $(parent).append($(relaisMap));
            $(relaisMap).show('slow');
        }
        $(".customer-adress").hide();
        $("div[class*=addrBookContainer]:visible").hide("slow");
        $("#AddressManager").hide();
        $("#hiddenDeliveryMode").val($(radioInput).val());
        initMap();
        showPagePoints();//#BRA-15010
        setTimeout(function () {
            localStorage.setItem("searchByDefault", "true");
            callBack();
        }, 500);
        scrollToPointsRelais(1000);
    }

    function appendRelaisGRPMap(callBack) {
        var relaisMap = $(".pRelaisDetailsGRP");
        var grpMap = $("#pointRelaisDetailsGRP");
        var detailRelais = $("#pointAcheminementDetail");
        var radioInput = $(".delivery-mode .form-horizontal").find("input[name='deliveryMode']:checked");
        if(showRelayPoint != null && showRelayPoint == true) {
            $(relaisMap).show('slow');
            $(grpMap).hide();
            $(detailRelais).show();
        }
        else {
            var parent = $(radioInput).closest(".radiostyle");
            $(detailRelais).hide();
            $(grpMap).show();
            $(parent).append($(relaisMap));
            $(relaisMap).show('slow');
        }
        $(".customer-adress").hide();
        $("div[class*=addrBookContainer]:visible").hide("slow");
        $("#AddressManager").hide();
        $("#hiddenDeliveryMode").val($(radioInput).val());
        initGRPMap();
        showPagePointsGRP();//#BRA-15010
        setTimeout(function () {
            localStorage.setItem("searchByDefault", "true");
            callBack();
        }, 500);
    }

    function appendDeliveryAddress(){
        var radioInput = $(".delivery-mode .form-horizontal").find("input[name='deliveryMode']:checked");
        var parent=$(radioInput).closest(".radiostyle");
        if($(parent).hasClass("pointsRelais")){
            appendRelaisMap();
            appendRelaisGRPMap();
        }else{
            var divAdress=$(".customer-adress");
            $(parent).append($(divAdress));
            $(divAdress).show();
            //append addEditAddressForm to selected standar delivery mode
            var addrEditAddressAnchor = $(".addEditAddressAnchor");
            var addrEditAddressFormContainer = $(".addEditAddressForm");
            $($(addrEditAddressFormContainer)).insertAfter($(parent));
            $($(addrEditAddressAnchor)).insertAfter($(parent));

            $(".registrated-address.addrBookContainer").hide();
            $(".pRelaisDetails").hide();
            $(".pRelaisDetailsGRP").hide();
        }
        $("#hiddenDeliveryMode").val($(radioInput).val());
        $(window).trigger('resize');
    }

    //Select DeliveryMode
    $(PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.trSelectDeliveryMode, function(e){
            if(!$("body").hasClass("emptyAddress") && !hasNoDeliveryAddress) {
                $.each( $(PURCHASE_TUNNEL.selectors.deliveryPage.trSelectDeliveryMode), function( i, element ){
                    $(element).removeClass('selected-radio');
                });
                $(this).addClass('selected-radio');
                if(!$(e.target).hasClass('tool-tip')){
                    var elementInput = $(this).find(PURCHASE_TUNNEL.selectors.deliveryPage.selectDeliveryMode);
                    if(!elementInput.is(":checked")) {
                        elementInput.prop("checked",true);
                        initDeliveryMode(elementInput[0]);
                    }
                }
            }
        });

    function HTMLunEscape(str) {
        return String(str)
            .replace(/&amp;/g, '&')
            .replace(/&#39;/g, "'")
    }

    $(function () {
        if($(".delivery-mode .form-horizontal").length > 0) initDeliveryMode($(".delivery-mode .form-horizontal").find("input[name='deliveryMode']:checked"));
    })

    document.addEventListener('addEmptyAddress', function(e){
        addEmptyAddress(e);
    }, false);

    document.addEventListener('addOrUpdateAddress', function(e){
        addOrUpdateAddress(e);
    }, false);

    addEmptyAddress = function (e) {
        e.preventDefault();
        spinnerON();
        var url = $("#deliveryAddAddessForm").attr("action");
        if (!$("[name=useAsBillingAddress]").prop('checked') && $("input[name=invoice]").length == 0) {
            url = $("#addressUrlValue").val()
        }
        $.post(url, $("#deliveryAddAddessForm").serialize().replace('g-recaptcha-response','recaptcha'))
            .done(function (result) {
                checkUserIfLoggedOut(result);
                var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(HTMLunEscape(result)));
                if (jsonResponse.success && jsonResponse.hasOwnProperty("addressesSection")) {
                    if (jsonResponse.hasOwnProperty("redirectTo") && isForfait) {
                        window.location.href = jsonResponse.redirectTo;
                    } else {
                        if ($('input[name=deliveryMode]:checked').length == 0) {
                            window.location.href = "/checkout/multi/choose-delivery";
                        } else {
                            $("#AddressesSection").hide();
                            $("body").removeClass("emptyAddress");
                            $.each($(PURCHASE_TUNNEL.selectors.deliveryPage.trSelectDeliveryMode), function (i, element) {
                                var elementInput = $(element).find(PURCHASE_TUNNEL.selectors.deliveryPage.selectDeliveryMode);
                                elementInput.prop("disabled", false);
                                $(element).removeAttr("title");
                            });
                            hasNoDeliveryAddress = false;
                            initDeliveryMode($('input[name=deliveryMode]:checked'));
                            $("#AddressesSection").html(jsonResponse.addressesSection);
                            $(window).trigger('resize');
                            if (jsonResponse.hasOwnProperty("message")) {
                                addMessage(jsonResponse.success, jsonResponse.message);
                                scrollToElement("#globalMessages");
                            } else {
                                $("#globalMessages").html("");
                                scrollToElement("#AddressesSection");
                            }
                            wannaChangeAddress = false;
                            $("#AddressesSection").show();
                            $(".total-card .submit-container .ui-btn-primary").removeClass("ui-btn-disabled");
                        }
                    }
                } else {
                    $("#chooseDeliveryEmptyPage").html(jsonResponse.addressForm);
                    if (jsonResponse.hasOwnProperty("message")) {
                        addMessage(jsonResponse.success, jsonResponse.message);
                        scrollToElement("#globalMessages");
                    } else {
                        scrollToElement("#AddressesSection");
                    }
                }
            })
            .fail(function () {

            })
            .always(function () {
                spinnerOFF();
            });
    }

    //AddAddressCaseEmptyAddress
    $(document).on("click", ".connected .addAddress_EmptyAddress", function(e){
        addEmptyAddress(e);
    });
    //Edit Address
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.editAddress, function(){
            wannaChangeAddress = true;
            var suffixCSS = $(this).attr("data-address-type");
            var addressBookContainer = $(".addrBookContainer"+suffixCSS+":hidden");
            if(addressBookContainer.length>0) {
                $(".address--active").removeClass("address--active");
                $("div[class*=addrBookContainer]:visible").hide("slow");
                $("#AddressManager").hide("slow");
                addressBookContainer.show('slow', function () {
                    scrollToElement(addressBookContainer);
                });
                $(this).parents(".address").addClass("address--active");
                if(isMobile()) {
                    $("#AddressManager").insertAfter($(".address--active").parent());
                }
            }
        });
    //Show Address Form (Add or Update)
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.addOrEditAddress, function(){
            var data = {
                type: $(this).attr("data-address-type"),
                target: $(this).attr("data-address-target")
            };
            if($(this)[0].hasAttribute("data-address-code")) {
                data.code = $(this).attr("data-address-code");
            }
            spinnerON();
            $.ajax({
                type: HTTP_METHODS.get,
                url: isGuestCheckout() ? PURCHASE_TUNNEL.ajaxUrl.guestLoadAddress : PURCHASE_TUNNEL.ajaxUrl.loadAddress,
                data: data
            }).done(function(result){
                checkUserIfLoggedOut(result);
                var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
                $("#AddressManager").html(jsonResponse.validatedForm);
                $("#selectedDeliveryMode").find("div[class*=addrBookContainer]").remove();
                $("div[class*=addrBookContainer]:visible").hide("slow");
                $("#AddressManager").show("slow", function () {
                    scrollToElement("#AddressManager");
                });
            }).fail(function(){

            }).always(function(){
                spinnerOFF();
            });
        });

    function isGuestCheckout() {
        return $("#fragmentDeliveryPage").hasClass('guest')||$("#fragmentPaymentPage").hasClass('guest');
    }
    //Cancel Edit Address From
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.cancelAddAddress, function(){
            scrollToElement("#AddressesSection");
            $('#AddressManager').hide("slow");
            $('#AddressManager').html("");
            $('#globalMessages').hide();
            $('#globalMessages').html("");
            scrollToElement('#globalMessages');
            $(".address--active").removeClass("address--active");
            wannaChangeAddress = false;
        });

    function addOrUpdateAddress(e) {
        e.preventDefault();
        var data = $(".create_update_address_form").serialize().replace('g-recaptcha-response','recaptcha');
        spinnerON();
        $.ajax({
            type: HTTP_METHODS.post,
            url: isGuestCheckout() ? PURCHASE_TUNNEL.ajaxUrl.guestAddAddress : PURCHASE_TUNNEL.ajaxUrl.addAddress,
            data: data + "&stepName=" + ($("#fragmentPaymentPage").length > 0 ? "payment" : "delivery")
        }).done(function (result) {
            checkUserIfLoggedOut(result);
            var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
            $("#globalMessages").html(jsonResponse.message);
            if (jsonResponse.success != "false") {
                $("#AddressesSection").html(jsonResponse.addressesSection);
                $(window).trigger('resize');
                scrollToElement("#AddressesSection");
                wannaChangeAddress = false;
                validateTheDeliveryMode($('input[name=deliveryMode]:checked'));
            } else {
                $("#AddressManager").html(jsonResponse.validatedForm);
            }
        }).fail(function () {

        }).always(function () {
            spinnerOFF();
            scrollToElement('#globalMessages');
            $('#globalMessages').show();
        });
    }

//Add or Update Address
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragmentForConnected)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.updateAddress, function(e){
            addOrUpdateAddress(e);
        });

    //Remove Addresse
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.removeAddress, function(e){
            e.preventDefault();
            var currentElement = $(this);
            var addressCode = currentElement.attr("data-address-code");
            spinnerON();
            $.ajax({
                type: HTTP_METHODS.get,
                url: isGuestCheckout() ? PURCHASE_TUNNEL.ajaxUrl.guestRemoveAddress+addressCode :PURCHASE_TUNNEL.ajaxUrl.removeAddress+addressCode,
            }).done(function(result){
                checkUserIfLoggedOut(result);
                var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
                if(jsonResponse.success) {
                    currentElement.parents(".address-box").remove();
                    addMessage(true, jsonResponse.message);
                }
            }).fail(function(){

            }).always(function(){
                spinnerOFF();
                scrollToElement('body');
            });
        });

    //Set Default Address
    $(PURCHASE_TUNNEL.selectors.multiple.deliveryAndPaymentPageFragment)
        .on("click", PURCHASE_TUNNEL.selectors.deliveryPage.setDefaultAddress, function(e){
            var currentElement = $(this);
            spinnerON();
            $.ajax({
                type: HTTP_METHODS.post,
                url: PURCHASE_TUNNEL.ajaxUrl.setDefaultAddress,
                data: {
                    addressId : currentElement.attr("data-address-id"),
                    type: currentElement.attr("data-address-type"),
                    stepName : $("#fragmentPaymentPage").length > 0 ? "payment" : "delivery"
                }
            }).done(function(result){
                checkUserIfLoggedOut(result);
                var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
                if(jsonResponse.success) {
                    $(PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment+" #AddressesSection,"+PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment+" #AddressesSection").html(jsonResponse.addressesSection);
                    addMessage(true, jsonResponse.message);
                    wannaChangeAddress = false;
                    validateTheDeliveryMode($('input[name=deliveryMode]:checked'));
                }
            }).fail(function(){

            }).always(function(){
                spinnerOFF();
                scrollToElement('body');
            });
        });

    $(window).resize(function() {
        if ($(this).height() == originalHeight) {

            if (isMobile()) {
                //If DeliveryPage or PaymentPage
                if ($(PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment)[0] || $(PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment)[0]) {
                    try {$('.tool-tip').tooltipster('destroy');}catch (err){}
                    $.each( $('.tool-tip'), function( i, element ){
                        $(element).attr("title", $(element).attr("data-title"));
                    });
                    $('.tool-tip').tooltipster({
                        position: 'right',
                        trigger: 'click',
                        contentAsHTML: true,
                        theme: 'tooltipster-ui',
                        functionBefore: function (instance, helper) {
                            helper.event.stopPropagation();
                            var content = $(instance._$origin["0"]).attr("data-title");
                            $(".ui-modal p").html(content);
                            openUiModal();
                            return false;
                        }
                    });

                    if ($( ".delivery-address.adress-container>.address-card" ).length == 0) {
                        $( ".addrBookContainerDelivery" ).insertAfter( $( ".delivery-address.adress-container>.address-card" ).get(0) );
                        $( ".addrBookContainerBilling" ).insertAfter( $( ".delivery-address.adress-container>.address-card" ).get(1) );
                    }
                    if($(".address--active")[0]) {
                        $("#AddressManager").insertAfter($(".address--active").parent());
                    }
                }
            }
            else {
                //If DeliveryPage or PaymentPage
                if ($(PURCHASE_TUNNEL.selectors.deliveryPage.deliveryFragment)[0] || $(PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment)[0]) {
                    try {$('.tool-tip').tooltipster('destroy');}catch (err){}
                    $.each( $('.tool-tip'), function( i, element ){
                        $(element).attr("title", $(element).attr("data-title"));
                    });
                    $('.tool-tip').tooltipster({
                        position: 'right',
                        trigger: 'click',
                        theme: 'tooltipster-ui',
                        contentAsHTML: true,
                        functionBefore: function (instance, helper) {
                            helper.event.stopPropagation();
                            $.each($.tooltipster.instances(), function(i, instance){
                                instance.close();
                            });
                        }
                    });

                    $( ".addrBookContainerDelivery" ).insertAfter( $( ".customer-adress" ) );
                    $( ".addrBookContainerBilling" ).insertAfter( $( ".customer-adress" ) );
                    $("#AddressManager").insertAfter($(".addEditAddressAnchor"));
                }
            }
        }
    });

    function openUiModal(){
        $(".ui-modal").removeClass("ui-modalHide").addClass("ui-modalShow");
        $(".ui-modal").show();
        $("body").css('position','fixed');
    }

    $(document)
        .on("click", ".ui-close-modal", function(){
            $(".ui-modal").removeClass("ui-modalShow").addClass("ui-modalHide");
            $(".ui-modal").hide();
            $("body").css('position','');
        });

    if($(".page-CartPage").length > 0 || $(".page-MultiStepCheckoutSummaryPage").length > 0 || $(".page-OrderConfirmationPage").length > 0 || $(".page-orders").length > 0) {
        $(window).trigger('resize');
    }

    /******************************
     PaymentPage
     *******************************/

    //ValidateTaxNumber
    $(PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment)
        .on("click", PURCHASE_TUNNEL.selectors.paymentPage.validateTaxNumber, function(e){
            validateLegalTaxNumber()
        });

    //ValidatePhoneNumber
    $(PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment)
        .on("click", PURCHASE_TUNNEL.selectors.paymentPage.validatePhoneNumber, function(e){
            validateMobilePhoneNumber()
        });


    //Select PaymentMode
    $(PURCHASE_TUNNEL.selectors.paymentPage.paymentFragment)
        .on("click", PURCHASE_TUNNEL.selectors.paymentPage.trSelectPaymentMode, function(e){
            $.each( $(PURCHASE_TUNNEL.selectors.paymentPage.trSelectPaymentMode), function( i, element ){
                $(element).removeClass('selected-radio');
            });
            $(this).addClass('selected-radio');
            if(!$(e.target).hasClass('tool-tip')){
                var elementInput = $(this).find(PURCHASE_TUNNEL.selectors.paymentPage.selectPaymentMode);
                if(!elementInput.is(":checked")) {
                    elementInput.prop("checked",true);
                }
            }
        });


    /******************************
     ConfirmationPage
     *******************************/

    if(!isMobile() && $(".page-OrderConfirmationPage").length > 0) {
        $(".confirm-total-card thead th").css({'height': $(".need-extra").outerHeight(), 'vertical-align': 'middle'});
    }

    if($(PURCHASE_TUNNEL.selectors.confirmationPage.registerProductsModal).length > 0) {
        $(PURCHASE_TUNNEL.selectors.confirmationPage.registerProductsModal).modal("show");
    }

    function updateSaveOrderProductsAttribute(e, userChoice) {
        e.preventDefault();
        var orderCode = $(this).attr("data-order");
        spinnerON();
        $(PURCHASE_TUNNEL.selectors.confirmationPage.registerProductsModal).modal("hide");
        $.ajax({
            type: HTTP_METHODS.post,
            url: PURCHASE_TUNNEL.ajaxUrl.registerProducts + orderCode,
            data: {status: userChoice}
        }).done(function (result) {
            checkUserIfLoggedOut(result);
            var jsonResponse = jQuery.parseJSON(escapeSingleQuoteJson(result));
            if(jsonResponse.message){
                addMessage(jsonResponse.success, jsonResponse.message);
            }
        }).fail(function () {
            addMessage(true, "ERROR");
        }).always(function () {
            spinnerOFF();
        });
    }

    //ACCEPTED RegisterProducts Of the Order
    $(PURCHASE_TUNNEL.selectors.confirmationPage.registerProductsModal)
        .on("click", PURCHASE_TUNNEL.selectors.confirmationPage.accepteRegisterProductsBtn, function(e){
            updateSaveOrderProductsAttribute.call(this, e, "ACCEPTED");
        });

    //REJECTED RegisterProducts Of the Order
    $(PURCHASE_TUNNEL.selectors.confirmationPage.registerProductsModal)
        .on("click", PURCHASE_TUNNEL.selectors.confirmationPage.rejectRegisterProductsBtn, function(e){
            updateSaveOrderProductsAttribute.call(this, e, "REJECTED");
        });
});

function showNewsLetterModalInCheckoutPage() {
    isTOSvalide().then(function(result) {
        if(!result)
            $('#ModalNewsLetter').modal();
    });
}

function submitNewsletter(){
    $.ajax({
        type: $("#FormNewsLetter").attr('method'),
        url: $("#FormNewsLetter").attr('action'),
        data: $("#FormNewsLetter").serialize()
    }).done(function(data){
        if(data == "ok") {
            $("#popinMessages").append("<div class='information_message positive'> <span class='single'></span> <span> "+newsLEtterSubscribeEmail+"</span> </div>");
            $("#FormNewsLetter .item-form-news").remove();
            $("#DoubleOptinButton").remove();
            $("#DoubleOptinButtonClose").show("#DoubleOptinButton");
        }else {
            $("#DoubleOptinButtonClose").click();
        }
    }).fail(function(){
        $('#errorSubscription').show();
    });
    $("#FormNewsLetter").submit();
}

function validateTOSAjaxService(url) {
    if(orderAlreadyCreated === false) {
        orderAlreadyCreated = true;
        var legalTaxNumber=$("#legal-tax-number").val();
        var legalTaxNumberData=typeof legalTaxNumber !== 'undefined'?"&legal-tax-number="+legalTaxNumber:'';
        var mobilePhone=$("#mobilePhone").val();
        var mobilePhoneData=typeof mobilePhone !== 'undefined'?"&mobilePhone="+mobilePhone:'';
        $.ajax({
            type: "POST",
            data: jQuery("#FormPaymentMode").serialize()+legalTaxNumberData+mobilePhoneData,
            url: url
        }).done(function(data){
            if (data.target == "WINDOW") {
                window.location.href = ACC.config.contextPath + data.url;
                return;
            }
            if (data.target == "POPUP"
                && data.modal) {
                modal = '.'
                    + data.code;
                if (data.modal == "ideal") {
                    jQuery(modal + " form select").html("");
                    for (var issuerID in data.issuers) {
                        jQuery(modal + " form select").append("<option value=" + issuerID + ">" + data.issuers[issuerID] + "</option>");
                    }
                }
                jQuery(
                    modal)
                    .show();
                jQuery(
                    modal)
                    .modal();
                jQuery(
                    modal
                    + " form")
                    .attr(
                        "action",
                        ACC.config.contextPath
                        + data.url);
                jQuery(
                    modal)
                    .on(
                        'hidden.bs.modal',
                        function () {
                            jQuery(
                                modal)
                                .hide();
                        });
            }
            if (data.target == "DIRECT") {
                $.ajax({
                    type: "POST",
                    url: data.url,
                    data: {"paymentMode": data.code}
                }).done(function(data){
                    $("body").append("<form id='sgaPaymentForm' style='display:none;' method='POST'></form>");
                    $("#sgaPaymentForm").attr('action', data.postUrl);
                    $.each(data.parameters, function (key, value) {
                        var newInput = $("<input type='hidden'/>");
                        newInput.attr('name', key);
                        newInput.attr('value', value);
                        $("#sgaPaymentForm").append(newInput);
                    });
                    $("#sgaPaymentForm").submit();
                }).fail(function(error){
                    console.log(error);
                });
            } else if (data.target === "SEAMLESS") {
                initAdyenProcess(data, $("button[data-price-value]").data("price-value"), $("button[data-currency]").data("currency"));
            }
            else if (data.modal != "ideal") {
                $("#PaymentResult").html(data.html);
                if ($("#PaymentResult form input[type=IMAGE]").length == 1 && $("#PaymentResult form input[name=PAYLIB]").length == 1) {
                    jQuery("#PaymentResult form input").trigger("click");
                    jQuery('#ModalPayment').remove();
                }
                $('#ModalPayment').show();
                $('#ModalPayment').modal();
                $('#ModalPayment').on('hidden.bs.modal', function () {
                    $('#ModalPayment').hide();
                })
            }
        }).fail(function(error){
            orderAlreadyCreated = false;
            $('#errorSubscription').show();
        });
    }
}

function placeSmapleOrder(){
    var legalTaxNumber=$("#legal-tax-number").val();
    var legalTaxNumberData=typeof legalTaxNumber !== 'undefined'?legalTaxNumber:'';
    $("#SmapleOrderLegalTaxNumber").val(legalTaxNumberData);
    var mobilePhone = $("#mobilePhone").val();
    var mobilePhoneData = typeof mobilePhone !== 'undefined' ? mobilePhone : '';
    $("#SampleOrderMobilePhone").val(mobilePhoneData);
    $("#placeSmapleOrder").submit();
}

function addMessage(success, message) {
    if(message.includes("information_message")) {
        $("#globalMessages").html(message);
    }else {
        var divElement=document.createElement("div");
        divElement.setAttribute("class", (success==true ? "information_message positive" : "information_message negative"));
        divElement.innerHTML = "<p>"+message+"</p>";
        $("#globalMessages").html(divElement);
    }
};

function isTOSvalide() {
    $(".skip[id^=error]").hide();
    var termsNotChecked = !jQuery('#rules').is(':checked');
    var paymentNotChecked = !jQuery('input[id^=payment-mode-]').is(':checked');
    var stopProcessing = false;

    if (termsNotChecked) {
        jQuery('#errorTOS').show();
        stopProcessing = true;
    }
    if (isSampleOrder===false && paymentNotChecked) {
        GSEB.functions.scrollTo('#globalMessages', $("header").height() + 10);
        addMessage(false,$("#errorPM span").text().trim());
        stopProcessing = true;
    }else{
        jQuery('#errorPM').hide();
    }
    if ($('#detachedPieceCG').length > 0 && !$('#detachedPieceCG').is(':checked')) {
        $('#errorCG-PD').show();
        stopProcessing = true;
    }
    else {
        $('#errorCG-PD').hide();
    }
    if ($('#repareServiceCG').length > 0 && !$('#repareServiceCG').is(':checked')) {
        $('#errorCG-RS').show();
        stopProcessing = true;
    } else {
        $('#errorCG-RS').hide();
    }
    if(!validateLegalTaxNumber()){
        stopProcessing=true;
    }
    if(!validateMobilePhoneNumber()){
        stopProcessing=true;
    }
    return new Promise(function (resolve,reject) {
        if (isGuestCheckout) {
          submitWithRecaptcha(document.querySelector('#guestCheckoutMailForm'));
          document.addEventListener("guestFinish", function(e) {
              isEmailGuestCheckoutValid().then(function (isValid) {
                if (!isValid)
                  stopProcessing = true;
                resolve(stopProcessing);
              });
          }, {once: true})
        } else {
          resolve(stopProcessing);
        }
    });
}

function isEmailGuestCheckoutValid() {
    return $.ajax({
        type: "POST",
        url: "/checkout/multi/guest-checkout-email/valid",
        async: false
    })
}

function confirmOrder(url, isDoubleOptin) {
    var self=$(event.target)
    $(self).addClass("disabled")
    $(self).prop("disabled",true)
    //CheckDeliveryValidity
    spinnerON();
    $.ajax({
        type: "POST",
        url: validateDeliveryModeUrl,
        data: {
            "deliveryModeCode": $("#deliveryModeCode").val()
        }
    }).done(function(data){
        if(data.valid) {
            //ValidateTOS
            isTOSvalide().then(function (result) {
                if(!result){
                    if(!isDoubleOptin){
                        $.ajax({
                            type: $("#FormNewsLetter").attr('method'),
                            data: $("#FormNewsLetter").serialize(),
                            url: $("#FormNewsLetter").attr('action')
                        });
                    }
                    if(isSampleOrder===true){
                        placeSmapleOrder();
                    }else{
                        validateTOSAjaxService(url);
                    }

                    if (typeof tC !== 'undefined' && typeof tC.event !== 'undefined' && typeof tC.event.clickCheckoutPay !== 'undefined') {
                        tC.event.clickCheckoutPay(this, {});
                    }
                    if(isNotWwwDomain){
                        demoEvent('tC.event.clickCheckoutPay', {});
                    }
                }
                else{
                    $(self).removeClass("disabled")
                    $(self).prop("disabled",false)
                }
            });
        } else {
            var modal = $("#ModalMessage");
            var modalBody = modal.find(".modal-body");
            var sb = new StringBuilder();
            var deliveryName = typeof data.deliveryModeName != "undefined" ? data.deliveryModeName : "";
            sb.append("<p style='margin-bottom: 20px;'>" + invalidDeliveryModeText.replace('{deliveryMode}', deliveryName) + "</p>");
            sb.append("<button class='btn btn-action' data-dismiss='modal' style='margin:0 auto; display: block; width: auto; text-align: center'>"+ closePopup +"</button>");
            modalBody.html(sb.toString());
            modal.show();
            modal.modal();
            modal.one('hidden.bs.modal', function () {
                window.location.href = deliveryPageUrl;
            });
        }
    }).fail(function(error){
        console.log(error);
        $(self).removeClass("disabled")
        $(self).prop("disabled",false)
    }).always(function(){
        spinnerOFF();
    });
    $('#ModalNewsLetter').find('.close').trigger("click");
}

function displayRelayPointInformationForm() {
    $.ajax({
        type: "GET",
        url: "/checkout/multi/show-relaypoint-informations",
        dataType: 'html'
    }).done(function (data) {
        $('#relayPointFormContainer').show();
        $('#relayPointFormContainer').html(data);
    });
}

$(document).on("submit", "#relayPointAddressForm", function(e){
    e.preventDefault();
    $.ajax({
        type: "POST",
        url: "/checkout/multi/set-relaypoint-informations",
        data: $(this).serializeArray(),
        beforeSend: function(arr, $form, options) {
            spinnerON("#relayPointFormContainer");
        },
    }).done(function (data) {
        $('#relayPointFormContainer').html(data);
        $("#globalMessages").empty();
        var valid=$('#relayPointFormContainer #isValidForm').val();
        if(valid){
            $("#globalMessages").append("<div class='information_message positive'> <span class='single'></span> <p> "+relayPointInformationFormValid+"</p> </div>");

            $('html, body').animate({
                scrollTop: $('#globalMessages').offset().top-200
            }, 500);
            $('#globalMessages').show();
        }

    }).fail(function(){
        addMessage(false, "ERROR");
    }).always(function(){
        spinnerOFF("#relayPointFormContainer");
    }) ;
});


function checkRelayPointAddressForm() {
    $.ajax({
        type: "POST",
        url: "/checkout/multi/set-relaypoint-informations",
        data: $("#relayPointAddressForm").serializeArray(),
        beforeSend: function(arr, $form, options) {
            spinnerON("#relayPointFormContainer");
        },
    }).done(function (data) {

        $('#relayPointFormContainer').html(data);
        var valid = $('#relayPointFormContainer #isValidForm').val();
        if (valid) {
            $("form#hiddenformDeliveryMode button").click();
        } else {
            $("#globalMessages").empty();
            $("#globalMessages").append("<div class='information_message negative'> <span class='single'></span> <p> " + relayPointInformationFormError + "</p> </div>");
            const scrollTo = isMobile
                ? $("#relayPointFormContainer").offset().top - 60
                : $("#globalMessages").offset().top - 200;
            $('html, body').animate({
                scrollTop: scrollTo
            }, 500);
        }
    }).fail(function () {
        addMessage(false, "ERROR");
        spinnerOFF("#relayPointFormContainer");
    }).always(function () {
        spinnerOFF("#relayPointFormContainer");
    });
}

function isRelayPointDeliveryMode(){
    var radioInput = $("#fragmentDeliveryPage .delivery-mode .form-horizontal").find("input[name='deliveryMode']:checked");
    var isActiveAddressesSection=$('#AddressesSection').hasClass('hidden');
    if(radioInput.length>0 && isActiveAddressesSection) {
        if ($(radioInput).attr("data-isprelais")=="true") {
            return true;
        }else{
            return false;
        }
    }
    return false;
}

function checkDeliveryModeValidity(){
    if (wannaChangeAddressOrPointRetrait()) {
        $('html, body').animate({
            scrollTop: 0
        }, 300);
    }else if(!hasNoDeliveryAddress && (typeof hasExternalErrorDeliveryMode === 'undefined' || (typeof hasExternalErrorDeliveryMode !== 'undefined' && hasExternalErrorDeliveryMode == false))) {
        $.ajax({
            type: "POST",
            url: validateDeliveryModeUrl,
            data: {
                "deliveryModeCode": $("#deliveryModeCode").val()
            }
        }).done(function(data){
            if(data.valid) {
                if(isRelayPointDeliveryMode()){
                    checkRelayPointAddressForm();
                }else{
                    $("form#hiddenformDeliveryMode button").click();
                }
            } else {
                var modal = $("#ModalMessage");
                var modalBody = modal.find(".modal-body");
                var sb = new StringBuilder();
                var deliveryName = typeof data.deliveryModeName != "undefined" ? data.deliveryModeName : "";
                sb.append("<p style='margin-bottom: 20px;'>" + invalidDeliveryModeText.replace('{deliveryMode}', deliveryName) + "</p>");
                sb.append("<button class='btn btn-action' data-dismiss='modal' style='margin:0 auto; display: block; width: auto; text-align: center'>"+ closePopup +"</button>");
                modalBody.html(sb.toString());
                modal.show();
                modal.modal();
                modal.one('hidden.bs.modal', function () {
                    window.location.href = deliveryPageUrl;
                });
            }
        }).fail(function(error){
            console.log(error);
        });
    }
}
/* BRA-15305 */
function validateLegalTaxNumber(offset) {
    var $legalTaxNumber = $("#legal-tax-number");
    if ($legalTaxNumber.length > 0) {
        $legalTaxNumber.removeClass('has-error');
        $legalTaxNumber.removeClass("success");
        $("#legalTaxMessagePatternErrors").hide();
        $("#legalTaxMessageErrors").hide();

        var legalTax = $legalTaxNumber.val();
        if (taxNumberRegEx) {
            var pattern = new RegExp(taxNumberRegEx);
            if (!pattern.test(legalTax)) {
                $("#legalTaxMessagePatternErrors").show();
                $legalTaxNumber.addClass('has-error');
                scrolltoElementForMobile($legalTaxNumber.closest('.tax-container'), offset);
                return false;
            }
        }
    }
    $legalTaxNumber.addClass("success");
    return true;
}

/* BRA-21263 */
function validateMobilePhoneNumber() {
    var $mobilePhone = $("#mobilePhone");
    if ($mobilePhone.length > 0) {
        $mobilePhone.removeClass('has-error');
        $mobilePhone.removeClass("success");
        $("#errorMobilePhoneMessagePattern").hide();
        $("#errorMobilePhoneMessage").hide();

        if (!$mobilePhone.val()) {
            $("#errorMobilePhoneMessage").show();
            $mobilePhone.addClass('has-error');
            scrolltoElementForMobile($mobilePhone.closest('.tax-container'));
            return false;
        }

        var mobilePhone = $mobilePhone.val();
        if (mobilePhoneRegEx) {
            var pattern = new RegExp(mobilePhoneRegEx);
            if (!pattern.test(mobilePhone)) {
                $("#errorMobilePhoneMessagePattern").show();
                $mobilePhone.addClass('has-error');
                scrolltoElementForMobile($mobilePhone.closest('.tax-container'));
                return false;
            }
        }
    }
    $mobilePhone.addClass("success");
    return true;
}

function validateEmailGuestCheckout(form) {
    event.preventDefault();
    var $form = $(form);
    var $email = $form.find('input[type=text]').first();
    var $recaptchaResponse = $form.find('input[name="g-recaptcha-response"]').first();
    var formData = {};
    formData['email'] = $email.val();
    formData['recaptcha'] = $recaptchaResponse.val();
    if ($email.length > 0) {
        $email.removeClass('has-error');
        $email.removeClass("success");
        $("#emailGcMessagePatternErrors").hide();
        $("#emailGcMessageErrors").hide();

        if (!$email.val()) {
            $("#emailGcMessageErrors").show();
            $email.addClass('has-error');
            scrolltoElementForMobile($email.closest('.tax-container'));
            dispatchCustomEvent("guestFinish");
            return false;
        }

        var email = $email.val();
        if (emailRegEx) {
            var pattern = new RegExp(emailRegEx);
            if (!pattern.test(email)) {
                $("#emailGcMessagePatternErrors").show();
                $email.addClass('has-error');
                scrolltoElementForMobile($email.closest('.tax-container'));
                dispatchCustomEvent("guestFinish");
                return false;
            }
        }
        $.ajax({
            contentType: "application/json",
            url: ACC.config.contextPath + "/checkout/multi/ajax/set-guest-checkout-email",
            data: JSON.stringify(formData),
            method: 'POST'
        }).done(function () {
            $email.addClass("success");
            dispatchCustomEvent("guestFinish");
            return true;
        }).fail(function () {
            $("#emailGcMessageErrors").show();
            $email.addClass('has-error');
            scrolltoElementForMobile($email.closest('.tax-container'));
            dispatchCustomEvent("guestFinish");
            return false;
        });
    }


}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, 'includes', {
        value: function(searchElement, fromIndex) {

            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }

            // 1. Let O be ? ToObject(this value).
            var o = Object(this);

            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;

            // 3. If len is 0, return false.
            if (len === 0) {
                return false;
            }

            // 4. Let n be ? ToInteger(fromIndex).
            //    (If fromIndex is undefined, this step produces the value 0.)
            var n = fromIndex | 0;

            // 5. If n ≥ 0, then
            //  a. Let k be n.
            // 6. Else n < 0,
            //  a. Let k be len + n.
            //  b. If k < 0, let k be 0.
            var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

            function sameValueZero(x, y) {
                return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
            }

            // 7. Repeat, while k < len
            while (k < len) {
                // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                // b. If SameValueZero(searchElement, elementK) is true, return true.
                if (sameValueZero(o[k], searchElement)) {
                    return true;
                }
                // c. Increase k by 1.
                k++;
            }

            // 8. Return false
            return false;
        }
    });
}

;( function ( factory ) {
    if ( typeof define === 'function' && define.amd ) {
        // AMD. Register module depending on jQuery using requirejs define.
        define( ['jquery'], factory );
    } else {
        // No AMD.
        factory( jQuery );
    }
}( function ( $ ){
    $.fn.addBack = $.fn.addBack || $.fn.andSelf;

    $.fn.extend({

        actual : function ( method, options ){
            // check if the jQuery method exist
            if( !this[ method ]){
                throw '$.actual => The jQuery method "' + method + '" you called does not exist';
            }

            var defaults = {
                absolute      : false,
                clone         : false,
                includeMargin : false,
                display       : 'block'
            };

            var configs = $.extend( defaults, options );

            var $target = this.eq( 0 );
            var fix, restore;

            if( configs.clone === true ){
                fix = function (){
                    var style = 'position: absolute !important; top: -1000 !important; ';

                    // this is useful with css3pie
                    $target = $target.
                    clone().
                    attr( 'style', style ).
                    appendTo( 'body' );
                };

                restore = function (){
                    // remove DOM element after getting the width
                    $target.remove();
                };
            }else{
                var tmp   = [];
                var style = '';
                var $hidden;

                fix = function (){
                    // get all hidden parents
                    $hidden = $target.parents().addBack().filter( ':hidden' );
                    style   += 'visibility: hidden !important; display: ' + configs.display + ' !important; ';

                    if( configs.absolute === true ) style += 'position: absolute !important; ';

                    // save the origin style props
                    // set the hidden el css to be got the actual value later
                    $hidden.each( function (){
                        // Save original style. If no style was set, attr() returns undefined
                        var $this     = $( this );
                        var thisStyle = $this.attr( 'style' );

                        tmp.push( thisStyle );
                        // Retain as much of the original style as possible, if there is one
                        $this.attr( 'style', thisStyle ? thisStyle + ';' + style : style );
                    });
                };

                restore = function (){
                    // restore origin style values
                    $hidden.each( function ( i ){
                        var $this = $( this );
                        var _tmp  = tmp[ i ];

                        if( _tmp === undefined ){
                            $this.removeAttr( 'style' );
                        }else{
                            $this.attr( 'style', _tmp );
                        }
                    });
                };
            }

            fix();
            // get the actual value with user specific methed
            // it can be 'width', 'height', 'outerWidth', 'innerWidth'... etc
            // configs.includeMargin only works for 'outerWidth' and 'outerHeight'
            var actual = /(outer)/.test( method ) ?
                $target[ method ]( configs.includeMargin ) :
                $target[ method ]();

            restore();
            // IMPORTANT, this plugin only return the value of the first element
            return actual;
        }
    });
}));

window.initAdyenProcess = function (data, value, currency) {

    $.ajax({
        type: "POST",
        url: data.url,
        data: {"paymentMode": data.code}
    }).done(function (paymentMethodsResponse) {
        $.ajax({
            type: "POST",
            url: GSEB.urls.adyenEnv,
            data: {"paymentMode": data.code}
        }).done(function (adyenEnv) {
            $('<link/>', {
                rel: 'stylesheet',
                href: 'https://checkoutshopper-' + adyenEnv.environment + '.adyen.com/checkoutshopper/sdk/' + adyenEnv.version + '/adyen.css',
                integrity: adyenEnv.sriCss,
                crossorigin:'anonymous'
            }).appendTo('head');
            $.ajax({
                dataType : "script",
                url      : "https://checkoutshopper-" + adyenEnv.environment + ".adyen.com/checkoutshopper/sdk/" + adyenEnv.version + "/adyen.js",
                attrs    : { integrity: adyenEnv.sriJs,crossorigin:"anonymous"},
            }).done(function (sdk, textStatus, jqxhr) {

                $('#fragmentPaymentPage').replaceWith('<div id="dropin-container"></div>');
                var configuration = {
                    locale: adyenEnv.locale,
                    environment: adyenEnv.environment.toLowerCase(),
                    clientKey:adyenEnv.clientKey,
                    paymentMethodsResponse: paymentMethodsResponse,
                    amount: {
                        value: value,
                        currency: currency
                    },
                    paymentMethodsConfiguration: {
                        card: {
                            hasHolderName: true,
                            holderNameRequired: true,
                            enableStoreDetails: false
                        },

                        facilypay_3x: {
                            visibility: {
                                personalDetails: "editable",
                                billingAddress: "hidden",
                                deliveryAddress: "hidden"
                            }
                        },
                        facilypay_4x: {
                            visibility: {
                                personalDetails: "editable",
                                billingAddress: "hidden",
                                deliveryAddress: "hidden"
                            }
                        },
                        facilypay_6x: {
                            visibility: {
                                personalDetails: "editable",
                                billingAddress: "hidden",
                                deliveryAddress: "hidden"
                            }
                        },
                        facilypay_10x: {
                            visibility: {
                                personalDetails: "editable",
                                billingAddress: "hidden",
                                deliveryAddress: "hidden"
                            }
                        },
                        facilypay_12x: {
                            visibility: {
                                personalDetails: "editable",
                                billingAddress: "hidden",
                                deliveryAddress: "hidden"
                            }
                        }
                    },

                    onSubmit: function (state, dropin) {

                        dropin.setStatus('loading');

                        // Your function calling your server to make the /payments request
                        // state.data.paymentMethod.paymentModeCode = data.code;
                        $.ajax({
                            type: "POST",
                            url: data.url.replace("/methods", "/do"),
                            headers: {'Idempotency-Key': adyenEnv.idempotencyKey},
                            data: JSON.stringify({
                                data: state.data,
                                paymentModeCode: data.code
                            }),
                            contentType: 'application/json',
                            dataType: 'json'
                        }).then(function(payment) {
                            // Drop-in will handle the action object from the /payments response
                            const parsedAction = JSON.parse(payment.action);
                            if ("ACTION" === payment.result && payment.action !== null) {
                                dropin.handleAction(parsedAction);
                            } else if ("SUCCESS" === payment.result) {
                                dropin.setStatus('success', {message: GSEB.properties.adyenPaymentSuccess});
                                setTimeout(function () {
                                    location.replace(data.url.replace("/methods", "/confirm"));
                                }, 2000);
                            } else if ("VALIDATION_PENDING" === payment.result) {
                                dropin.setStatus('success', {message: GSEB.properties.adyenPaymentSuccess});
                                setTimeout(function () {
                                    location.replace(data.url.replace("/methods", "/confirm?isInPending=true"));
                                }, 2000);
                            } else {
                                dropin.setStatus('error', {message: GSEB.properties.adyenPaymentFailure});
                                setTimeout(function () {
                                    location.replace(data.url.replace("/methods", "/deny"));
                                }, 2000);
                            }
                        }).catch(function (error) {
                            throw Error(error);
                        });
                    },
                    onAdditionalDetails: function (state, dropin) {
                        $.ajax({
                            type: "POST",
                            url: data.url.replace("/methods", "/details"),
                            headers: {'Idempotency-Key': adyenEnv.idempotencyKey},
                            data: JSON.stringify({
                                "paymentModeCode": data.code,
                                "paymentDetails": state.data
                            }),
                            contentType: 'application/json',
                            dataType: 'json'
                        }).then(function(payment) {
                            // Drop-in will handle the action object from the /payments respons
                            const parsedAction = JSON.parse(payment.action);
                            if ("ACTION" === payment.result && payment.action !== null) {
                                dropin.handleAction(parsedAction);
                            } else if ("SUCCESS" === payment.result) {
                                dropin.setStatus('success', {message: GSEB.properties.adyenPaymentSuccess});
                                setTimeout(function () {
                                    location.replace(data.url.replace("/methods", "/confirm"));
                                }, 2000);
                            } else {
                                dropin.setStatus('error', {message: GSEB.properties.adyenPaymentFailure});
                                setTimeout(function () {
                                    location.replace(data.url.replace("/methods", "/deny"));
                                }, 2000);
                            }
                        }).catch(function (error) {
                            throw Error(error);
                        });
                    }
                };

                if( typeof paymentMethodsResponse.paymentMethods !== 'undefined') {
                    paymentMethodsResponse.paymentMethods.forEach(function (paymentMethod) {
                        if (typeof adyenPaymentMethod["" + paymentMethod.type + ""] !== 'undefined' && adyenPaymentMethod["" + paymentMethod.type + ""].name != null) {
                            if (typeof configuration.paymentMethodsConfiguration["" + paymentMethod.type + ""] !== 'undefined') {

                                configuration.paymentMethodsConfiguration["" + paymentMethod.type + ""].name = adyenPaymentMethod["" + paymentMethod.type + ""].name;
                            } else {

                                configuration.paymentMethodsConfiguration["" + paymentMethod.type + ""] = {};
                                configuration.paymentMethodsConfiguration["" + paymentMethod.type + ""].name = adyenPaymentMethod["" + paymentMethod.type + ""].name;
                            }

                        }

                    });
                };
                if(GSEB.properties.card != null){
                    configuration.paymentMethodsConfiguration.card.name = {};
                    configuration.paymentMethodsConfiguration.card.name = GSEB.properties.card;
                }

                AdyenCheckout(configuration)
                    .then(function(checkout){
                        var dropinConfiguration = {
                            openFirstPaymentMethod: true
                        };
                        checkout.create('dropin', dropinConfiguration).mount('#dropin-container');
                    })
                    .catch(function(error){
                        console.log("Error initiating Adyen dropin: " + error);
                    });
            });
        });
    }).fail(function (error) {
        throw Error(error);
    }).always(function() {
        $('html, body').animate({scrollTop: 0}, 300);
    });
};
